import { inject, Injectable } from '@angular/core';

import { useResolveBrokenSensorsAlert } from 'app/alerts/composables/use-resolve-broken-sensors-alert';
import { UISocketDataMessage } from 'app/shared/models/UISocket';
import { SocketAction, SocketActionHandler } from 'app/shared/services/SocketActionHandler';

import { DeviceCommandsStore } from '../device-commands.store';
import { DEVICE_COMMANDS } from '../models/Device';
import { ExecutionStatus } from '../models/Execution';

interface UISocketExecutionUpdateMessage extends UISocketDataMessage {
    job_id: string;
    status: ExecutionStatus;
    failureType?: string;
}

@Injectable()
export class ExecutionStateChangedHandler implements SocketActionHandler {
    readonly action: SocketAction = 'executionStateChanged';

    private readonly deviceCommands = inject(DeviceCommandsStore);
    private readonly resolveBrokenSensorsAlert = useResolveBrokenSensorsAlert();

    handle(message: UISocketExecutionUpdateMessage): void {
        const execution = this.deviceCommands.statusChanged(message.job_id, message.status, message.failureType);
        if (
            execution?.state === DEVICE_COMMANDS.REMOVE_BROKEN_SENSORS &&
            execution.status === ExecutionStatus.COMPLETED &&
            execution.deviceId
        ) {
            void this.resolveBrokenSensorsAlert.resolve(execution.deviceId);
        }
    }
}
